// Utility functions

const getWindowHeight = () => {
  return (
    "innerHeight" in window ?
    window.innerHeight :
    document.documentElement.offsetHeight
  )
}

// Utility function to iterate over objects, ruby-style
// Usage: mapObject(<object>, (key, value) => {...})
const mapObject = (object, callback) => (
  Object.keys(object).map(
    (key) => callback(key, object[key])
  )
)

export {
  getWindowHeight,
  mapObject
}



// WEBPACK FOOTER //
// ./src/lib/util.js